import { getCookie } from '../utils/cookiesUtils';

export default function authHeader() {
  const authorization = getCookie('dashboard_token');

  if (authorization) {
    return { 'authorization': authorization };
  }
}
